export const dropDownDefault = "Make your selection";
export const politeDropDownDefault = "Please select";
export const appointmentApiUrl = '/api/sitecore/WebAppointment/SaveNewJsonAppointment';
export const myChartPfaScheduleUrl = "https://mychart.clevelandclinic.org/openscheduling/standalone?id=64012588,64018110,64018111,64018112,64018113,64018114,64018701&vt=553";